// CondensedBucket — internal pipeline artifact (Session 19AK).
//
// Output of condense_per_kind stage. NOT stored in IngestPackage; lives only
// inside the ingest StageContext for downstream stages to consume.
//
// Why per-kind aggregation:
//   When a course uploads N source files spread across multiple kinds
//   (textbook + lecture_notes + case_study + …), naively scoring every slot
//   per chapter via keyword match dilutes attention. Each stage ends up
//   reading 1-2 of the wrong slots when chapter titles overlap.
//
//   Condensing per kind first gives each downstream stage ONE markdown blob
//   per kind (with chapter H2 boundaries already merged), so chapter slicing
//   becomes deterministic regex over `## chapter X` headers.
//
// Restructure-not-summarize contract:
//   The condense step REORGANIZES form (H2/H3 hierarchy, table-ize raw lists,
//   strip slide footers / page numbers / parser noise) but does NOT compress
//   content. Every fact / number / quote / name from the source must survive
//   into the bucket. AI is explicitly told this is NOT a summary.
import { z } from 'zod';
import { SourceSlotKindSchema } from './source-slot.js';
export const CondensedBucketSchema = z.object({
    /** Source kind this bucket aggregates (textbook / lecture_notes / case_study / etc.). */
    kind: SourceSlotKindSchema,
    /** Restructured markdown — same content as source slots of this kind, just
     *  reorganized into a unified H2-per-chapter / H3-per-section layout. */
    markdown: z.string(),
    /** How many source slots got merged into this bucket (debug / DEVLOG). */
    sourceCount: z.number().int().min(0),
    /** Original filenames merged into this bucket (debug / DEVLOG). */
    sourceFilenames: z.array(z.string()),
    /** Per-slot provenance headers (format: "filename · label [format] [priority=N/10]").
     *  Preserved so downstream stages can weigh source signal quality even after
     *  condensing. Optional for backward compat with existing serialized buckets. */
    sourceHeaders: z.array(z.string()).optional(),
    /** Byte length of `markdown` for cost / token estimation downstream. */
    byteLength: z.number().int().min(0),
});
//# sourceMappingURL=condensed-bucket.js.map